module.exports = `<!DOCTYPE html>
<html>
<title>Trojan Energy Limited - Document Portal</title>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css">
<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Raleway">
<script src="https://kit.fontawesome.com/0ee23d3d9a.js" crossorigin="anonymous"></script>
<style>
html,body,h1,h2,h3,h4,h5 {font-family: "Raleway", sans-serif}

  .container {
    display: table;
    }

  .row  {
    display: table-row;
    }

  .left, .right, .middle {
    display: table-cell;
    padding: 10px;
    }
</style>
<body class="w3-light-grey">

<!-- Top container -->
<div class="w3-bar w3-top w3-black w3-large" style="z-index:4">
  <button class="w3-bar-item w3-button w3-hide-large w3-hover-none w3-hover-text-light-grey" onclick="w3_open();"><i class="fa fa-bars"></i>  Menu</button>
  <span class="w3-bar-item w3-left"><img src="images/Trojan_Logo.png" alt="Trojan Energy Limited" height="50px"></img></span>
  <h2>Documents Controller</h2>
</div>

<!-- Sidebar/menu -->
<nav class="w3-sidebar w3-collapse w3-white w3-animate-left" style="z-index:3;width:300px;" id="mySidebar"><br>
  <div class="w3-container w3-row">
    <br />
    <div class="w3-col s4">
      <img src="images/avatars/avatar2.png" class="w3-circle w3-margin-right" style="width:46px">
    </div>
    <div class="w3-col s8 w3-bar">
      <span>Welcome, <strong>Marsha</strong></span><br>
      <a href="#" class="w3-bar-item w3-button"><i class="fa fa-envelope"></i></a>
      <a href="#" class="w3-bar-item w3-button"><i class="fa fa-user"></i></a>
      <a href="#" class="w3-bar-item w3-button"><i class="fa fa-cog"></i></a>
    </div>
  </div>
  <hr>
  <div class="w3-container">
    <h5>Actions</h5>
  </div>
  <div class="w3-container">
    Search By
    <div class="w3-bar-block">
        <a href="#" class="w3-bar-item w3-button w3-padding-16 w3-hide-large w3-dark-grey w3-hover-black" onclick="w3_close()" title="close menu"><i class="fa fa-remove fa-fw"></i>  Close Menu</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  SDRL Code</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  System Hierarchy</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Model Number</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Serial Number</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Discipline</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Location</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Author</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Client</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Project</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Workscope</a><br><br>
    </div>
  </div>
  <div class="w3-container">
    Document Management
    <div class="w3-bar-block">
        <a href="#" class="w3-bar-item w3-button w3-padding-16 w3-hide-large w3-dark-grey w3-hover-black" onclick="w3_close()" title="close menu"><i class="fa fa-remove fa-fw"></i>  Close Menu</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Create Document Number</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Upload Document</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Workflow Document</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Create Transmittal</a>
    </div>
  </div>
</nav>


<!-- Overlay effect when opening sidebar on small screens -->
<div class="w3-overlay w3-hide-large w3-animate-opacity" onclick="w3_close()" style="cursor:pointer" title="close side menu" id="myOverlay"></div>

<!-- !PAGE CONTENT! -->
<div class="w3-main" style="margin-left:300px;margin-top:43px;">

  <!-- Header -->
  <header class="w3-container" style="padding-top:22px">
    <h5><b><i class="fa fa-dashboard"></i> Quick Links</b></h5>
  </header>

  <div class="w3-row-padding w3-margin-bottom">
    <div class="w3-quarter"><a href="doc_standards" style="text-decoration:none;">
      <div class="w3-container w3-blue-gray w3-padding-16">
        <div class="w3-left"><i class="fa fa-scale-balanced w3-xxxlarge"></i></div>
        <div class="w3-right">
          <h3>52</h3>
        </div>
        <div class="w3-clear"></div>
        <h4>Standards</h4>
      </div>
      </a>
    </div>
    <div class="w3-quarter"><a href="doc_guidelines" style="text-decoration:none;">
      <div class="w3-container w3-dark-gray w3-padding-16">
        <div class="w3-left"><i class="fa fa-book w3-xxxlarge"></i></div>
        <div class="w3-right">
          <h3>8</h3>
        </div>
        <div class="w3-clear"></div>
        <h4>Guidelines</h4>
      </div>
      </a>
    </div>
    <div class="w3-quarter"><a href="doc_policies" style="text-decoration:none;">
      <div class="w3-container w3-gray w3-padding-16">
        <div class="w3-left"><i class="fa fa-file w3-xxxlarge"></i></div>
        <div class="w3-right">
          <h3>23</h3>
        </div>
        <div class="w3-clear"></div>
        <h4>Policies</h4>
      </div>
      </a>
    </div>
    <div class="w3-quarter"><a href="doc_technical" style="text-decoration:none;">
      <div class="w3-container w3-orange w3-text-white w3-padding-16">
        <div class="w3-left"><i class="fa fa-compass-drafting w3-xxxlarge"></i></div>
        <div class="w3-right">
          <h3>35</h3>
        </div>
        <div class="w3-clear"></div>
        <h4>Technical</h4>
      </div>
      </a>
    </div>
  </div>
  <div class="w3-panel">
    <div class="w3-row-padding" style="margin:0 -16px">
      <div class="w3-half">
        <h5>Location Specific Drawings</h5>
        <div>
        <object id="mapObject" width="100%" height="100%" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik" style="border: 1px solid black">
        </object>
        </div>
        <br/>
        <small><a href="https://www.openstreetmap.org/#map=18/51.53170/-0.22124">View Larger Map</a></small>
      </div>
      <div class="w3-half">
        <h5>Most Popular TEL Documents</h5>
        <table class="w3-table w3-striped w3-white">
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td><i>2.2</i></td>
            <td><i>240 Views</i></td>
          </tr>
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td><i>2.2</i></td>
            <td><i>240 Views</i></td>
          </tr>
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td><i>2.2</i></td>
            <td><i>240 Views</i></td>
          </tr>
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td><i>2.2</i></td>
            <td><i>240 Views</i></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <div class="w3-panel">
    <div  class="w3-row-padding" style="margin:0 -16px">
      <div class="w3-half">
        <h5>Your Most Recent Documents</h5>
        <table class="w3-table w3-striped w3-white">
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td>2.2</td>
            <td>2022.05.05 23:25</td>
          </tr>
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td>2.2</td>
            <td>2022.05.05 23:25</td>
          </tr>
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td>2.2</td>
            <td>2022.05.05 23:25</td>
          </tr>
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td><i>2.2</i></td>
            <td><i>2022.05.05 23:25</i></td>
          </tr>
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td>2.2</td>
            <td>2022.05.05 23:25</td>
          </tr>
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td>2.2</td>
            <td>2022.05.05 23:25</td>
          </tr>
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td>2.2</td>
            <td>2022.05.05 23:25</td>
          </tr>
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td>2.2</td>
            <td>2022.05.05 23:25</td>
          </tr>
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td>2.2</td>
            <td>2022.05.05 23:25</td>
          </tr>
          <tr>
            <td><i class="fa fa-circle-check w3-text-green w3-large"></i></td>
            <td>1000-HYD-E02-000123</td>
            <td>STEP Project : Mortimer Road System Schematics</td>
            <td>2.2</td>
            <td>2022.05.05 23:25</td>
          </tr>
        </table>
      </div>
      <div class="w3-half">
  <div class="w3-container">
    <h5>Latest Workflow Messages</h5>
    <div class="w3-row">
      <div class="w3-col m2 text-center">
        <img class="w3-circle" src="images/avatars/avatar3.png" style="width:96px;height:96px">
      </div>
      <div class="w3-col m10 w3-container">
        <h4>James <span class="w3-opacity w3-medium">Sep 29, 2021, 9:12 PM</span></h4>
        <h5><span class="w3-opacity w3-medium">1000-SYS-E04-000554</span></h5>
        <p>Marsha, can you please add a section on customer training and then reworkflow. Thanks</p><br>
      </div>
    </div>

    <div class="w3-row">
      <div class="w3-col m2 text-center">
        <img class="w3-circle" src="images/avatars/avatar1.png" style="width:96px;height:96px">
      </div>
      <div class="w3-col m10 w3-container">
        <h4>Adam <span class="w3-opacity w3-medium">Sep 28, 2021, 10:15 PM</span></h4>
        <h5><span class="w3-opacity w3-medium">3000-TEL-H15-001087</span></h5>
        <p>Reviewed the text. Minor editorial comments. Include those and progress the workflow.</p><br>
      </div>
    </div>
  </div>
      </div>
    </div>
  </div>
  <hr />
  <hr />
  <br>
  <!--
  <div class="w3-container w3-dark-grey w3-padding-32">
    <div class="w3-row">
      <div class="w3-container w3-third">
        <h5 class="w3-bottombar w3-border-red">To Action</h5>
        <p>Rejected Workflows</p>
        <p>Review Overdue</p>
        <p></p>
      </div>
      <div class="w3-container w3-third">
        <h5 class="w3-bottombar w3-border-orange">In-Progress</h5>
        <p>Unreleased Documents</p>
        <p>Workflow Comments</p>
        <p>Review Ongoing</p>
      </div>
      <div class="w3-container w3-third">
        <h5 class="w3-bottombar w3-border-green">Completed</h5>
        <p>Document Releases</p>
        <p>Transmittals</p>
        <p>Review Cycles /  Approvals</p>
      </div>
    </div>
  </div> -->

  <!-- Footer -->
  <footer class="w3-container w3-padding-16 w3-light-grey">
    <h4>TROJAN ENERGY LIMITED, 2022</h4>
    <p>Powered by <a href="https://www.w3schools.com/w3css/default.asp" target="_blank">w3.css</a></p>
  </footer>

  <!-- End page content -->
</div>

<script>
// Get the Sidebar
var mySidebar = document.getElementById("mySidebar");

// Get the DIV with overlay effect
var overlayBg = document.getElementById("myOverlay");

// Toggle between showing and hiding the sidebar, and add overlay effect
function w3_open() {
  if (mySidebar.style.display === "block") {
    mySidebar.style.display = "none";
    overlayBg.style.display = "none";
  } else {
    mySidebar.style.display = "block";
    overlayBg.style.display = "block";
  }
}

// Close the sidebar with the close button
function w3_close() {
  mySidebar.style.display = "none";
  overlayBg.style.display = "none";
}

// Change the map focus point
function changeMapFocus() {
    location = Math.floor(Math.random() * 10);
    var mapObject = document.getElementById("mapObject");

    switch(location) {
        case 0:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 1:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 2:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 3:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 4:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 5:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 6:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 7:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 8:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 9:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        default:
            data="https://www.openstreetmap.org/#map=17/56.96566/-2.21837";
            break;
    }
}

</script>

</body>
</html>`;
